import React, { useState } from 'react';
import PopupWithForm from '../PopupWithForm/PopupWithForm';

const API_URL = process.env.REACT_APP_API_URL;

function ForgotPasswordPopup({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    try {
      const response = await fetch(`${API_URL}/users/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      setMessage(data.message || "If the email exists, a reset link will be sent.");
    } catch {
      setMessage('There was a problem. Please try again later.');
    }
    setIsSubmitting(false);
  };

  return (
    <PopupWithForm
      title="Forgot Password"
      name="forgot-password"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      buttonText={isSubmitting ? 'Sending...' : 'Send Reset Link'}
      isButtonEnabled={!!email && !isSubmitting}
      isLoggedIn={false}
      buttonClassName="login"
      closeButtonClassName="login-close"
    >
      <label className="popup__formfield">
        <input
          className="popup__input"
          name="email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
      </label>
      {message && (
        <div style={{ marginTop: 10, color: "#1976d2", fontSize: "0.95em" }}>
          {message}
        </div>
      )}
    </PopupWithForm>
  );
}

export default ForgotPasswordPopup;
